import React from 'react';

const Testimonials = () => {
  const reviews = [
    {
      name: 'Alexander Wright',
      role: 'Chief Technology Officer',
      company: 'SecureFi Global',
      avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=300&q=80',
      text: 'Hungry Top Technologies transformed our legacy loan processing into a lightning-fast AI digital lending platform. Their engineering caliber is top-tier.',
      rating: 5,
    },
    {
      name: 'Sophia Martinez',
      role: 'Founder & CEO',
      company: 'Apex Digital Solutions',
      avatar: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&w=300&q=80',
      text: 'Working with Hungry Top on our enterprise cloud migration and microservices was seamless. They delivered ahead of schedule with 99.99% reliability.',
      rating: 5,
    },
    {
      name: 'David Chen',
      role: 'Head of Product',
      company: 'Veloce AI Labs',
      avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=300&q=80',
      text: 'Their custom AI credit scoring and fraud detection models reduced our manual verification workload by over 90%. Exceptional design and execution.',
      rating: 5,
    },
  ];

  return (
    <section
      style={{
        padding: '64px 0',
        position: 'relative',
        zIndex: 2,
        background: 'linear-gradient(180deg, #0B0F24 0%, #060816 100%)',
      }}
    >
      <div className="ht-container">
        {/* Section Header */}
        <div className="section-header">
          <span className="section-tag">TESTIMONIALS</span>
          <h2 className="text-gradient">Trusted by Founders & Enterprise Leaders</h2>
          <p>
            Here is what executives and product leaders say about working with Hungry Top Technologies.
          </p>
        </div>

        {/* Reviews Grid */}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))',
            gap: '24px',
          }}
        >
          {reviews.map((rev, idx) => (
            <div
              key={idx}
              className="glass-card"
              style={{
                padding: '32px',
                borderRadius: '24px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
              }}
            >
              <div>
                {/* Rating Stars */}
                <div style={{ display: 'flex', gap: '4px', color: '#F59E0B', marginBottom: '20px' }}>
                  {[...Array(rev.rating)].map((_, i) => (
                    <i key={i} className="fas fa-star" style={{ fontSize: '0.9rem' }}></i>
                  ))}
                </div>

                <p style={{ fontSize: '1rem', color: '#E2E8F0', lineHeight: 1.7, fontStyle: 'italic', marginBottom: '28px' }}>
                  "{rev.text}"
                </p>
              </div>

              {/* Author Info */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '14px', paddingTop: '20px', borderTop: '1px solid rgba(255, 255, 255, 0.08)' }}>
                <img
                  src={rev.avatar}
                  alt={rev.name}
                  style={{ width: '48px', height: '48px', borderRadius: '50%', objectFit: 'cover', border: '2px solid #6C63FF' }}
                />
                <div>
                  <h4 style={{ fontSize: '1rem', color: '#FFF', fontWeight: 700, margin: 0 }}>
                    {rev.name}
                  </h4>
                  <span style={{ fontSize: '0.82rem', color: '#A3A8B8', display: 'block' }}>
                    {rev.role} • <strong style={{ color: '#00D4FF' }}>{rev.company}</strong>
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;


